import { render, staticRenderFns } from "./insightsReport.vue?vue&type=template&id=f2b4aa32&"
import script from "./insightsReport.vue?vue&type=script&lang=js&"
export * from "./insightsReport.vue?vue&type=script&lang=js&"
import style0 from "./insightsReport.vue?vue&type=style&index=0&id=f2b4aa32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports